import { FC } from 'react';
import { IOption } from 'components/elements/CustomSelect';
import { CustomModal } from 'components/elements/CustomModal';
import { ICityFormValues } from 'types';
import { CityForm } from '../CityForm';

interface ManageCityModalProps {
	isOpen: boolean;
	onClose: () => void;
	initialValues: ICityFormValues;
	onSubmit: (values: ICityFormValues) => void;
	buttonText: string;
	title: string;
	regionOptions: IOption[];
	regionOptionsLoading: boolean;
	onRegionSearch: (search: string) => void;
	prefixOptions: IOption[];
	shortPrefixOptions: IOption[];
	initialRegionTitle?: string;
	onDeleteRequest?: () => void;
	canDelete?: boolean;
}

export const ManageCityModal: FC<ManageCityModalProps> = ({
	isOpen,
	onClose,
	initialValues,
	onSubmit,
	buttonText,
	title,
	regionOptions,
	regionOptionsLoading,
	onRegionSearch,
	prefixOptions,
	shortPrefixOptions,
	initialRegionTitle = '',
	onDeleteRequest,
	canDelete = false,
}) => {
	return (
		<CustomModal open={isOpen} onClose={onClose} title={title} maxWidth="md" fullWidth>
			<CityForm
				initialValues={initialValues}
				onSubmit={onSubmit}
				buttonText={buttonText}
				regionOptions={regionOptions}
				regionOptionsLoading={regionOptionsLoading}
				onRegionSearch={onRegionSearch}
				prefixOptions={prefixOptions}
				shortPrefixOptions={shortPrefixOptions}
				initialRegionTitle={initialRegionTitle}
				onDeleteRequest={onDeleteRequest}
				canDelete={canDelete}
			/>
		</CustomModal>
	);
};
